// src/hooks/useProductPageContent.js
import { useState } from 'react';
import { getProductNewArrival } from '../services/pageContentService';

const useProductNewArrival = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchProductNewArrival = async () => {
        setStatus('loading');
        setError('');

        try {
            const response = await getProductNewArrival();

            if (response?.status !== 'Error') {
                setData(response.data ?? response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchProductNewArrival,
        data,
        status,
        error,
        resetStatus
    };
};

export default useProductNewArrival;
